import React from 'react'
import Withdraw_head from './withdraw_head'
import Withdraw_sec2 from './withdraw_sec2'
import Withdraw_sec3 from './withdraw_sec3'

export default function Withdraw() {
  return (
    <>
      <Withdraw_head />
      <Withdraw_sec2 />
      <Withdraw_sec3 />   
    </>
  )
}
  